import { Component, inject, input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { DifficultyLevelComponent } from '../../dialogs/difficulty-level/difficulty-level';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import * as _ from "lodash";
import { AllStatus } from '../../../../core/services/status/all-status';

@Component({
  selector: 'app-health-practices',
  imports: [TranslatePipe],
  templateUrl: './health-practices.html',
  styleUrl: './health-practices.scss'
})

export class HealthPractices {
  readonly dialog = inject(MatDialog);
  configuration = inject(ConfigurationService);
  allStatus = inject(AllStatus);
  points = input<number>(0);
  maxPoints = input<number>(0);

  openWindow(): void{
    const dialogConfig = new MatDialogConfig();
          dialogConfig.panelClass = 'nutri-templs';
          dialogConfig.backdropClass = 'nutri-templs-backdrop';
          dialogConfig.data ={
            points: this.points(),
            maxPoints: this.maxPoints()
          }
    const dialogRef = this.dialog.open(DifficultyLevelComponent, dialogConfig);
  }

  countFiles(): number{
      const questInfo = JSON.parse(sessionStorage.getItem('QuestInfo') as string);
      let countFiles = 0;
      if(questInfo.data?.pdf_files){
        const listFiles = _.isEmpty(questInfo.data?.pdf_files[this.allStatus.valueDifficulty().result.level]) ? [] : questInfo.data?.pdf_files[this.allStatus.valueDifficulty().result.level];
        if(this.configuration.configuration.profile.nsp){
          countFiles = this.filterNsp(listFiles);
        }else{
          countFiles = this.filterNotNsp(listFiles);
        }
      }

      return countFiles;
    }

    filterNsp(listFiles: any[]){
        const resF = listFiles.filter((item: any) => item.nsp === true );
        let countFiles = 0;
        if(_.isEmpty(resF)){
          return this.filterNotNsp(listFiles);
        }else{
          countFiles = resF.length;
        }
        return countFiles;
      }
    
      filterNotNsp(listFiles: any[]){
        const resF = listFiles.filter((item: any) => item.nsp === false );
        let countFiles = 0;
        if(_.isEmpty(resF)){
          countFiles = 0;
        }else{
          countFiles = resF.length;
        }    
        return countFiles;
      }
  }
